import React from 'react';
import styles from './styles.module.scss';
import { useField } from 'formik';
import { NumericFormat } from 'react-number-format';

const TextInput = props => {
  const { name, label = '', required = true, autoComplete = 'on', maxLength = 255 } = props;
  const [field, meta] = useField(props);

  return (
    <fieldset className={styles.container}>
      <label htmlFor={name}>
        {label} {required ? <span className={styles.required}>*</span> : null}
      </label>
      <input {...field} {...props} required={required} maxLength={maxLength} autoComplete={autoComplete} />
      {meta.touched && meta.error ? <p className={styles.error}>{meta.error}</p> : null}
    </fieldset>
  );
};

export default TextInput;

export const TextInput2 = props => {
  const { reff, name, label = '', required = true, autoComplete = 'on', maxLength = 255 } = props;
  const [field, meta] = useField(props);

  return (
    <fieldset className={styles.container}>
      <label htmlFor={name}>
        {label} {required ? <span className={styles.required}>*</span> : null}
      </label>
      <input ref={reff} {...field} {...props} required={required} maxLength={maxLength} autoComplete={autoComplete} />
      {meta.touched && meta.error ? <p className={styles.error}>{meta.error}</p> : null}
    </fieldset>
  );
};

export const TextAreaInput = props => {
  const { name, label = '', required = true, autoComplete = 'on' } = props;
  const [field, meta] = useField(props);

  return (
    <fieldset className={styles.container}>
      <label htmlFor={name}>
        {label} {required ? <span className={styles.required}>*</span> : null}
      </label>
      <textarea {...field} {...props} required={required} maxLength={255} autoComplete={autoComplete} />
      {meta.touched && meta.error ? <p className={styles.error}>{meta.error}</p> : null}
    </fieldset>
  );
};

export const AmountInput2 = props => {
  const { disabled = false } = props;
  const [field] = useField(props);

  return (
    <fieldset className={styles.container}>
      <NumericFormat
        decimalScale={2}
        disabled={disabled}
        allowNegative={false}
        thousandSeparator={true}
        customInput={TextInput}
        inputmode="numeric"
        // empty string on prefix prop is iintentional to fix bug from package
        prefix={" "}
        {...field}
        {...props}
      />
    </fieldset>
  );
};
